import React, { useMemo, useState } from 'react';
import CommonTab from '../tabComponent/CommonTab';
import InsuranceConfig from './InsuranceConfig';
import ChatbotConfig from './ChatbotConfig';
var GlobalSettings = function () {
    var _a = useState(0), activeTab = _a[0], setActiveTab = _a[1];
    var tabs = useMemo(function () { return [
        {
            label: 'Insurance Policy',
            content: React.createElement(InsuranceConfig, null),
        },
        {
            label: 'Chatbot FAQs',
            content: React.createElement(ChatbotConfig, null),
        },
    ]; }, []);
    return (React.createElement(CommonTab, { tabs: tabs, activeIndex: activeTab, onTabChange: setActiveTab }));
};
export default GlobalSettings;
